//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

export enum INSTAGRAM_POST_UPLOADER_ACTIONS {
  SET_CONTEXT = 'INSTAGRAM_POST_UPLOADER/SET_CONTEXT',

  OPEN_MODAL = 'INSTAGRAM_POST_UPLOADER/OPEN_MODAL',
  CLOSE_MODAL = 'INSTAGRAM_POST_UPLOADER/CLOSE_MODAL',

  UPDATE_POST_URL_VALUE = 'INSTAGRAM_POST_UPLOADER/UPDATE_URL_VALUE',
  VALIDATE_POST_URL_VALUE = 'INSTAGRAM_POST_UPLOADER/VALIDATE_URL_VALUE',

  ADD_POST = 'INSTAGRAM_POST_UPLOADER/ADD_POST',
  REQUEST_POST_UPLOAD = 'INSTAGRAM_POST_UPLOADER/REQUEST_POST_UPLOAD',
  RECEIVE_POST_UPLOAD_SUCCEEDED = 'INSTAGRAM_POST_UPLOADER/RECEIVE_POST_UPLOADED_SUCCEEDED',
  RECEIVE_POST_UPLOAD_FAILED = 'INSTAGRAM_POST_UPLOADER/RECEIVE_POST_UPLOAD_FAILED',

  UPDATE_ERROR_MESSAGE = 'INSTAGRAM_POST_UPLOADER/UPDATE_ERROR_MESSAGE',
  RESET_ERROR_MESSAGE = 'INSTAGRAM_POST_UPLOADER/RESET_ERROR_MESSAGE',
}

export enum INSTAGRAM_POST_UPLOADER_CONTEXT {
  LIBRARY = 'library',
}
